const Footer = () => {
    return (
      <footer className="bg-black text-white p-4 text-center">
        <p>© Waffle. Todos os direitos reservados. By Guilherme Henrique</p>
      </footer>
    );
  };
  
  export default Footer;
  